import {
  Automation,
  mockAutomationConfigQueryOperationQuery,
  mockCreateAutomationMutation,
  mockDeleteAutomationMutation,
  mockPlaybooksQueryOperationQuery,
  mockUpdateAutomationMutation,
  Playbook,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const mockAutomations: Automation[] = [
  {
    __typename: 'Automation',
    id: 'automation-1',
    playbookId: 'playbook-1',
    name: 'AbuseIPDB',
    description: 'IP Reputation',
    cseResourceType: 'ENTITY',
    cseResourceSubTypes: ['_ip', '_hostname'],
    executionTypes: ['NEW_INSIGHT', 'INSIGHT_CLOSED', 'ON_DEMAND'],
    created: '0000',
    lastUpdated: '0000',
    createdBy: 'Renee Dennis',
    lastUpdatedBy: 'Renee Dennis',
    enabled: true,
  },
  {
    __typename: 'Automation',
    id: 'automation-2',
    playbookId: 'playbook-2',
    name: 'VirusTotal',
    description:
      'Scan File, IP Reputation, File Reputation, Domain Reputation, Get Alert Details',
    cseResourceType: 'ENTITY',
    cseResourceSubTypes: ['_username'],
    executionTypes: ['ON_DEMAND'],
    created: '0000',
    lastUpdated: '0000',
    createdBy: 'Renee Dennis',
    lastUpdatedBy: 'Renee Dennis',
    enabled: false,
  },
  {
    __typename: 'Automation',
    id: 'automation-3',
    playbookId: 'playbook-3',
    name: 'CISCO UMbrella Investigate DIF',
    description:
      'File Reputation, Vulnerability Search, Domain Reputation, Malware Search, IP Reputation, Get Alert Details, URL Reputation, File Reputation V2, Domain Reputation 2',
    cseResourceType: 'INSIGHT',
    cseResourceSubTypes: [],
    executionTypes: ['NEW_INSIGHT', 'INSIGHT_CLOSED', 'ON_DEMAND'],
    created: '0000',
    lastUpdated: '0000',
    createdBy: 'Renee Dennis',
    lastUpdatedBy: 'Renee Dennis',
    enabled: true,
  },
  {
    __typename: 'Automation',
    id: 'automation-4',
    playbookId: 'playbook-4',
    name: 'URLscan.io Essential',
    description:
      'This is an essential playbook used to enrich incidents with URLscan.io. The playbook will collect the desired URL and launch three different enrichment actions using URLscan.',
    cseResourceType: 'INSIGHT',
    cseResourceSubTypes: [],
    executionTypes: ['NEW_INSIGHT'],
    created: '0000',
    lastUpdated: '0000',
    createdBy: 'Renee Dennis',
    lastUpdatedBy: 'Renee Dennis',
    enabled: true,
  },
];

export const mockPlaybooks: Playbook[] = [
  {
    __typename: 'Playbook',
    id: 'playbook-1',
    name: 'AbuseIPDB',
    description: 'IP Reputation',
    type: 'Playbook type 1',
  },
  {
    __typename: 'Playbook',
    id: 'playbook-2',
    name: 'VirusTotal',
    description:
      'Scan File, IP Reputation, File Reputation, Domain Reputation, Get Alert Details',
    type: 'Playbook type 2',
  },
  {
    __typename: 'Playbook',
    id: 'playbook-3',
    name: 'Another playbook',
    description:
      'Scan File, IP Reputation, File Reputation, Domain Reputation, Get Alert Details',
    type: 'Playbook type 2',
  },
  {
    __typename: 'Playbook',
    id: 'playbook-4',
    name: 'Yet another playbook',
    description:
      'Scan File, IP Reputation, File Reputation, Domain Reputation, Get Alert Details',
    type: 'Playbook type 2',
  },
];

export const mockAutomation: Automation = {
  __typename: 'Automation',
  id: 'automation-1',
  playbookId: mockPlaybooks[0].id,
  name: mockPlaybooks[0].name,
  description: mockPlaybooks[0].description,
  cseResourceType: 'INSIGHT',
  cseResourceSubTypes: [],
  executionTypes: ['ON_DEMAND'],
  enabled: true,
  created: '00000000',
  createdBy: 'Renee Dennis',
};

export const handlers = [
  // READ AUTOMATIONS
  mockAutomationConfigQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          automations: {
            __typename: 'AutomationPage',
            total: mockAutomations.length,
            objects: mockAutomations,
          },
        },
      });
    }
  ),

  // DELETE AUTOMATION
  mockDeleteAutomationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          deleteAutomation: {
            __typename: 'DeleteAutomation',
            ok: true,
          },
        },
      });
    }
  ),

  // READ PLAYBOOKS
  mockPlaybooksQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          playbooks: mockPlaybooks,
        },
      });
    }
  ),

  // AUTOMATION UPDATE
  mockUpdateAutomationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          updateAutomation: {
            __typename: 'UpdateAutomation',
            data: {
              __typename: 'Automation',
              cseResourceSubTypes: [],
              executionTypes: ['ON_DEMAND'],
              enabled: true,
            },
          },
        },
      });
    }
  ),

  // AUTOMATION CREATE
  mockCreateAutomationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          createAutomation: {
            __typename: 'CreateAutomation',
            data: mockAutomation,
          },
        },
      });
    }
  ),
];
